/**
 * Decorator que aplica um delay antes de invocar um método.
 *
 * @category Decorator
 *
 * @param delay O delay em milisegundos para serem esperados antes de invocar o método.
 *
 * @example
 * ```ts
 * import { Debounce } from '@ids/tools';
 *
 * export class ExampleClass {
 *  count = 0;
 *
 *  @Debounce(500)
 *  onClick() {
 *    this.count++;
 *    console.log(`Button clicked ${this.count} times`);
 *  }
 * }
 * ```
 */
export const Debounce =
  (delay: number): MethodDecorator =>
  (_target: object, _key: PropertyKey, propertyDescriptor: PropertyDescriptor) => {
    const original = propertyDescriptor.value;
    let timer: ReturnType<typeof setTimeout>;

    propertyDescriptor.value = function (...args: Parameters<typeof original>) {
      clearTimeout(timer);
      timer = setTimeout(() => original.apply(this, args), delay);
    };
  };
